import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Alert } from '../models/alert-class';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root',
})
export class AlertsService {
  constructor(
    private router: Router,
    public globalService: GlobalService,
  ) {}

  showAlerts(_alertas?: Alert[], _typeclass?: string) {
    // Navega para a página de alertas — a página carrega os dados frescos via CheckAllAlerts
    // NÃO guardamos aqui para evitar duplicação: CheckAllAlerts já combina todas as fontes
    this.router.navigate(['/clientarea/alertas']);
  }
}
